import { CheckOutlined } from '@ant-design/icons'
import { Link, useLocation } from '@remix-run/react'
import { SupportTicket } from '@zenstackhq/runtime/models'
import { Button, Flex } from 'antd'
import { OrganizationMemberFromContext } from '~/core/context/organization/hooks/useOrganizationMembers'
import { DesignSystem } from '~/core/designSystem'
import { OrganizationType } from '~/features/organization/common'
import { OrganizationContactCommon } from '~/features/organizationContact/common'
import { ButtonLoadingOnClick } from '~/features/shared/components'
import { Icon } from '~/features/shared/icons'
import { DesignBox } from '~/plugins/designbox'
import { useData } from './hooks/useData'
import { useLogic } from './hooks/useLogic'

type Props = {
  ticket: SupportTicket
  organization: OrganizationType
  organizationMemberAgent: OrganizationMemberFromContext
  onRefresh: () => Promise<any> | any
}

export const Ticket = ({
  ticket,
  organization,
  organizationMemberAgent,
  onRefresh,
}: Props) => {
  const designSystem = DesignSystem.use()
  const location = useLocation()

  const data = useData({ ticket })
  const logic = useLogic({ ticket: data.ticket, organizationMemberAgent })

  const toBack = location.pathname.split('/').slice(0, -1).join('/')

  const handleChange = async (status: SupportTicket['status']) => {
    await logic.update({ id: data.ticket.id, status })
    await data.refetch()
    await onRefresh()
  }

  if (!data.contact) {
    return (
      <Flex justify="center">
        <DesignBox.LoaderOverlay />
      </Flex>
    )
  }

  const isOpen = data.ticket.status === 'OPEN'
  const color = OrganizationContactCommon.Helper.getColor(data.contact)
  const title = [data.contact.firstname, data.contact.lastname]
    .filter(Boolean)
    .join(' ')

  return (
    <>
      <Flex className="w-full " align="center" gap={8}>
        <Link to={toBack}>
          <Button
            icon={<Icon name="chevron-left" />}
            type="text"
            className="pl-0"
          >
            {designSystem.isMobile ? '' : 'All tickets'}
          </Button>
        </Link>

        <DesignBox.UserAvatar
          title={title}
          subtitle={data.contact.email}
          propsAvatar={{
            size: 'default',
            style: {
              background: color,
              display: designSystem.isMobile ? 'none' : undefined,
            },
          }}
        />

        <Flex justify="end" flex={1}>
          {!isOpen && (
            <ButtonLoadingOnClick onClick={() => handleChange('OPEN')}>
              Re-open
            </ButtonLoadingOnClick>
          )}
          {isOpen && (
            <ButtonLoadingOnClick
              type="primary"
              onClick={() => handleChange('CLOSED')}
              icon={<CheckOutlined />}
            >
              {designSystem.isMobile ? '' : 'Resolved'}
            </ButtonLoadingOnClick>
          )}
        </Flex>
      </Flex>

      {/* <Flex className="w-full py-2">
        <Questions ticket={data.ticket} onChange={handleChange} />
      </Flex> */}
    </>
  )
}
